export const EMAIL_KEY = 'Email';
export const FACEBOOK_KEY = 'Facebook';
export const TWITTER_KEY = 'Twitter';
export const LINKEDIN_KEY = 'LinkedIn';
export const INSTAGRAM_KEY = 'Instagram';
export const YOUTUBE_KEY = 'YouTube';
